export interface HttpErrorPayload {
  readonly statusCode: number;
  readonly message: string;
  readonly correlationId?: string;
  readonly serverPayload?: unknown;
  readonly cause?: unknown;
}

export class HttpError extends Error {
  public override readonly name = 'HttpError';

  public readonly statusCode: number;

  public readonly correlationId?: string;

  public readonly serverPayload?: unknown;

  constructor(payload: HttpErrorPayload) {
    super(payload.message);
    this.statusCode = payload.statusCode;
    if (payload.correlationId !== undefined) this.correlationId = payload.correlationId;
    if (payload.serverPayload !== undefined) this.serverPayload = payload.serverPayload;
    if (payload.cause !== undefined) {
      Object.defineProperty(this, 'cause', { value: payload.cause, enumerable: false });
    }
  }

  static isHttpError(value: unknown): value is HttpError {
    return value instanceof HttpError;
  }
}

export const HTTP_ERROR_NETWORK = 0;
